export const styles = () => ({
    info: {
        marginTop: -10,
        fontSize: 15
    },
    defaultFontSize: {
        fontSize: 14
    }
});
